<table>
  <thead>
  <th colspan="2">Group</th>
  <th colspan="4">Right (single)</th>
  <th colspan="3">Right (multiple)</th>
  </thead>
  <thead>
  <th>Name</th>
  <th>Id</th>
  <th>Back, Write</th>
  <th>Back, Read</th>
  <th>Front, Write</th>
  <th>Front, Read</th>
  <th>Back</th>
  <th>Front</th>
  <th>All</th>
  </thead>
  <tr *ngFor="let rightGroupUi of userRightsGroupUis">

    <th>{{rightGroupUi.groupName}}</th>
    <th>{{rightGroupUi.groupId}}</th>

    <th class="right-column"><input type="checkbox" (change)="rightGroupUi.backWriteChanged()"
                                    [(ngModel)]="rightGroupUi.backWrite"></th>
    <th class="right-column"><input type="checkbox" (change)="rightGroupUi.backReadChanged()"
                                    [(ngModel)]="rightGroupUi.backRead"></th>
    <th class="right-column"><input type="checkbox" (change)="rightGroupUi.frontWriteChanged()"
                                    [(ngModel)]="rightGroupUi.frontWrite"></th>
    <th class="right-column"><input type="checkbox" (change)="rightGroupUi.frontReadChanged()"
                                    [(ngModel)]="rightGroupUi.frontRead"></th>
    <th class="right-column"><input type="checkbox"
                                    [(ngModel)]="rightGroupUi.isAllBackSelected"></th>
    <th class="right-column"><input type="checkbox"
                                    [(ngModel)]="rightGroupUi.isAllFrontSelected"></th>
    <th class="right-column"><input type="checkbox"
                                    [(ngModel)]="rightGroupUi.isAllSelected"></th>

</table>
